import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento', 'orcamento');

const orcamentoActions = {
  anos: { method: 'GET', url: `${basePath}/anos` },
  meses: { method: 'GET', url: `${basePath}/meses` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  buscar: { method: 'GET', url: `${basePath}/{codigo}` },
  cancelar: { method: 'PUT', url: `${basePath}/cancelar/{id}` },
  desdobramentos: { method: 'GET', url: `${basePath}/desdobramentos/{id}` },
  finalizar: { method: 'PUT', url: `${basePath}/finalizar/{id}` },
  gravar: { method: 'POST', url: `${basePath}` },
  linhasInvestimento: { method: 'GET', url: `${basePath}/linhas-investimento/{codigo}` },
  listar: { method: 'GET', url: `${basePath}?completo=true` },
  listarAprovados: { method: 'GET', url: `${basePath}?status=APROVADO&descricao={descricao}&colunaOrdenacao=descricao` },
  listarDestinoAprovados: { method: 'GET', url: `${basePath}?status=APROVADO&descricao={descricao}&idOrcamentoOrigem={idOrcamentoOrigem}&colunaOrdenacao=descricao` },
  logs: { method: 'GET', url: `${basePath}{/id}/logs` },
  orcamentoCompleto: { method: 'GET', url: `${basePath}/completo/{codigo}` },
  saldo: { method: 'GET', url: `${basePath}/saldo/{codigo}` },
  transferir: { method: 'PUT', url: `${basePath}/transferir/{object}` },
  buscarConsumo: { method: 'GET', url: `${basePath}{/id}/consumo` },
  buscarOrcamento: { method: 'GET', url: `${basePath}/buscar/{id}` },
};

export default resource => resource(`${basePath}`, {}, orcamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/orcamento-cad.js